<template>
  <div style="display: flex; align-items: center">
    <v-autocomplete
      :items="customerList"
      :loading="loading"
      item-text="title"
      item-value="id"
      solo
      hide-no-data
      hide-selected
      label="Müşteri Ara"
      :model-value="props.modelValue"  
      @update:model-value="handleModelValue" 
      v-model:search="searchTerm"
      @update:search="handleSearch"
    ></v-autocomplete>
    <v-btn color="blue" @click="addCustomer" style="margin-left: 8px">
      <v-icon>mdi mdi-account-group</v-icon>
    </v-btn>

    <v-dialog v-model="showDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Yeni Müşteri Ekle</span>
        </v-card-title>
        <v-card-text>
          <CustomerForm 
            v-if="showDialog"
            v-model="newCustomer"
            @updateCustomer="updateCustomer"
            @closeDialog="showDialog = false"
            @fetchCustomerList="fetchCustomerList"
            @saved="handleSaved"
            @cancelled="showDialog = false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import debounce from "lodash/debounce";
import CustomerForm from './CustomerForm.vue';

export default {
  name: "CustomerSelect",
  components: {
    CustomerForm
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const store = useStore();
    const searchTerm = ref("");
    const showDialog = ref(false);
    const newCustomer = ref({});
    
    const customerList = computed(() => store.state.customerList);
    const loading = computed(() => store.state.loading);

    const handleSearch = debounce((term) => {
      if (term && term.length >= 2) {
        store.dispatch("fetchCustomers", term);
      }
    }, 300);

    const handleModelValue = (value) => {
      emit('update:modelValue', value);
    };

    const addCustomer = () => {
      newCustomer.value = {}; // Yeni müşteri nesnesini sıfırla
      showDialog.value = true;
    };

    const updateCustomer = (customer) => {
      newCustomer.value = customer;
    };

    const fetchCustomerList = () => {
      store.dispatch("fetchCustomers", searchTerm.value);
    };

    const handleSaved = () => {
      showDialog.value = false;
      fetchCustomerList();
    };

    return {
      props,
      searchTerm,
      customerList,
      loading,
      showDialog,
      newCustomer,
      handleSearch,
      handleModelValue,
      addCustomer,
      updateCustomer,
      fetchCustomerList,
      handleSaved
    };
  },
};
</script>